module.exports = __webpack_public_path__ + "static/media/vuesax-login-bg.eb4e894d.jpg";